import React from 'react';

export interface Instructor {
    id: string;
    name: string;
    title: string;
    grade: string;
    image?: string; // Optional image URL
    imagePosition?: string; // Optional CSS object-position (e.g., 'center top', '50% 20%')
    bio: React.ReactNode;
}

export const instructors: Instructor[] = [
    {
        id: 'mr-hutcheson',
        name: 'Mr Hutcheson',
        title: 'Club Instructor',
        grade: '5th Degree',
        image: '/images/MrHutcheson.png',
        bio: (
            <>
                <p>
                    Currently a 5th Degree, Mr Hutcheson has competed at events prior to 1993 and a lot since 2008. He feels that it is important to still compete at least once between the Black Belt grades. It sets a good example to the students and helps to keep his skills tested.
                </p>
                <br />
                <p>
                    Mr Hutcheson entered the World Cup in Slovenia in 2022, competed in 4 events at both and narrowly missed out on 2 potential medal places. He was the Bronze medalist in patterns at the Welsh Open in 2024, AETA Open English patterns champion in 2024, which he successfully defended in 2025 and went on to add the Open British title 2025 as well.
                </p>
                <br />
                <p>
                    He went to the ITF World Cup 2024 in Argentina, entering all 4 events and reached the quarter finals.
                </p>
                <br />
                <p>
                    In November 2024, Mr Hutcheson was promoted to 5th Degree.
                </p>
                <br />
                <p>
                    Mr Hutcheson holds a Class A Umpire's Certificate, which was gained in 2025.
                </p>
                <br />
                <p>
                    During 2019, he attended the first ITF Coach's Course, which was held in Ireland and was the catalyst to him coaching at the World Cups in Koper, Slovenia in 2022 and the World Cup in Argentina in 2024, where he helped to coach an incredibly successful team.
                </p>
                <br />
                <p>
                    Mr Hutcheson tries to attend every UK based International Instructors Course and International Umpires Course and managed to attend both in Wales in 2025. These help to keep him up to date with any changes that the ITF Technical or Umpire committees make and ensures that our students get the most up to date instruction.
                </p>
                <br />
                <p>
                    We have 9 Black Belts in the club, some are away at university currently and hopefully we will have a few more in 2026. All of active Black Belts regularly help with classes, gradings, competitions and are really supportive to our students.
                </p>
            </>
        ),
    },
    {
        id: 'mr-early',
        name: 'Mr Early',
        title: 'Assistant Instructor',
        grade: '2nd Degree',
        image: '/images/MrEarly.png',
        bio: (
            <>
                <p>
                    Started his training in his teens, continued training at university and then when he moved to Cranbrook in 2008, he joined us.
                </p>
                <br />
                <p>
                    Mr Early has competed in the World Cup in 2012 in Brighton and more recently at the Open English last year, where he won Gold in the Senior Male Power Event and Bronze in Patterns.
                </p>
                <br />
                <p>
                    A notable Umpire at our events, always looking to improve and deliver the best refereeing possible.
                </p>
                <br />
                <p>
                    He is always around to support the club and our students, covers classes when he can and is part of our strong team of assistant instructors.
                </p>
                <br />
                <p>
                    One of Mr Early’s sons also trains with us and hopefully the day will come that Mr Early gets to present his son with his Black Belt.
                </p>
                <br />
                <p>
                    Mr Early leads from the front and is a great class motivator.
                </p>
            </>
        ),
    },
    {
        id: 'miss-wilson',
        name: 'Miss Wilson',
        title: 'Assistant Instructor',
        grade: '2nd Degree',
        image: '/images/MissWilson.png',
        bio: (
            <>
                <p>
                    Miss Wilson came to us aged 4 and has been through TKD Tigers, TKD Children, previous iterations and is now very much in the senior ranks.
                </p>
                <br />
                <p>
                    She has competed from a very young age, picking up some medals in her colour belt years and most notably, helping the girls team win a Silver medal in the 2022 World Cup in Slovenia. She will be looking to add to that in the 2026 World Cup later this year.
                </p>
                <br />
                <p>
                    Miss Wilson helps whenever asked and is a role model to the children, especially to the girls, who all look up to her.
                </p>
                <br />
                <p>
                    She is a competent umpire and is keen to learn more, loves coaching others, and is still learning what it’s like to be at the front of the class, teaching.
                </p>
            </>
        ),
    },
    {
        id: 'mr-morrissey',
        name: 'Mr Morrissey',
        title: 'Assistant Instructor',
        grade: '1st Degree',
        image: '/images/MrMorrissey.png',
        bio: (
            <>
                <p>
                    Mr Morrissey started much the same time as Miss Wilson and they came through the grades together.
                </p>
                <br />
                <p>
                    He has also been an enthusiastic umpire and coach, helping out when he could fit it in around his exams.
                </p>
                <br />
                <p>
                    The help that he has given also cannot be understated, and we look forward to his returns from university.
                </p>
            </>
        ),
    }
];
